module.exports = __webpack_public_path__ + "img/NissanLeafMotor2.eae85362.jpg";